import Global from '../../store/global-selectors';

export class ShipstationConnectReader {
  constructor({ state }) {
    if (!state) {
      throw new Error(`expected value for state, got: ${state}`);
    }
    this.state = state;
  }

  get workstations() {
    return Global.selectConnectWorkstations(this.state);
  }

  get allScales() {
    const scales = Global.selectConnectScales(this.state) || [];
    return scales.reduce((acc, scaleGroup) => [...acc, ...scaleGroup.scales], []);
  }

  get scale() {
    const scales = this.allScales;
    const defaultScale = Global.selectConnectDefaultScale(this.state) || {};
    return scales.find((s) => s.id === defaultScale.id);
  }

  get hasConnect() {
    const hasActiveWorkstation = this.workstations.some((ws) => ws.isOnline);
    return hasActiveWorkstation;
  }
}
